import { render } from "./KRPlacardLayout.vue?vue&type=template&id=51a6ba96&scoped=true"
import script from "./KRPlacardLayout.vue?vue&type=script&lang=js"
export * from "./KRPlacardLayout.vue?vue&type=script&lang=js"

import "./KRPlacardLayout.vue?vue&type=style&index=0&id=51a6ba96&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51a6ba96"

export default script